import React from "react";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import OwBadge from "../../../shared/OwBadge/OwBadge";
import BetaBadge from "../../../shared/BetaBadge/BetaBadge";

type Props = {
    title: string;
    detail: string;
    toggleFn?: (e: any, subProp?: string) => void;
    isActive?: boolean;
    showDisableConfirm?: boolean;
    name: string;
    component?: any;
    toggledOnComponent?: any;
    disabled?: boolean;
    optionClassName?: string;
    betaBadge?: boolean;
};

export const SettingsRow: React.FC<Props> = (props) => {
    const classWidth = "w-20";

    if (props.component) {
        return (
            <tr>
                <td className={`text-end ${classWidth} ${props.optionClassName || ""}`}>
                    <div>
                        <OwLabel title={props.title} className={"d-inline-flex me-2"} />
                    </div>
                    <div className={"mt-2"}>
                        <OwLabel title={props.detail} className={"text-muted mt-4"} preserveNewlines={true} />
                    </div>
                </td>
                <td>{props.component}</td>
            </tr>
        );
    } else {
        return (
            <tr className="SettingsRow">
                <td className={`text-end ${classWidth} ${props.optionClassName || ""}`}>
                    <div>
                        <OwLabel title={props.title} className={"d-inline-flex me-2"} />
                    </div>
                    {props.betaBadge ? <BetaBadge /> : null}
                    <div className={"mt-2"}>
                        <OwLabel title={props.detail} className={"text-muted mt-4"} preserveNewlines={true} />
                    </div>
                </td>
                <td>
                    <div className={"d-flex"}>
                        <div className={""}>
                            <OwToggle
                                active={props.isActive!}
                                name={props.name}
                                fn={props.toggleFn!}
                                label={""}
                                showDisableConfirm={props.showDisableConfirm}
                                disabled={props.disabled}
                            />
                        </div>
                    </div>
                    {props.toggledOnComponent && props.isActive ? props.toggledOnComponent : null}
                </td>
            </tr>
        );
    }
};
